//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data: function data() {
		return {
			currentPage: 'Page List',
			role: window.user.role
		};
	},

	methods: {
		setCurrentPage: function setCurrentPage(page) {
			this.currentPage = page;

			Event.$emit('current-page', page);
		}
	},
	mounted: function mounted() {
		var $el = this;

		if (window.user.role == 'property-manager') {
			this.currentPage = 'Prospects';
			Event.$emit('current-page', 'Prospects');
		}

		Event.$on('change-page', function (page) {
			$el.currentPage = page;
			Event.$emit('current-page', page);
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/CMSNavigation.vue
// module id = LCBA
// module chunks = 0 1